export const KLARNA: {minTotal: number; installments: number} = {
    installments: 4,
    minTotal: 10,
};

export const KLARNA_SDK_URL = 'https://x.klarnacdn.net/kp/lib/v1/api.js';

export const KLARNA_CONTAINER_ID = 'klarna-payments-container';
export const PAYMENT_METHOD_KLARNA = 'klarna';
